<template>
  <div>
    <div class="main-content-container container-fluid px-4">
    	<div>
    		<div class="page-header row no-gutters py-4">
    			<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
            <span class="text-uppercase page-subtitle">Centro de postulaciones</span>
            <h3 class="page-title">Visión general</h3>
    		  </div>
    	   </div>
      </div>
      <div class="row">
        <div class="col-lg-12" v-for="(request, index) in requests" :key="index">
          <div class="card card-small card-post mb-4">
            <div class="card-body">
              <p class="card-text text-muted">
                {{ request.message }}
              </p>
            </div>
            <div class="card-footer border-top d-flex">
              <div class="card-post__author d-flex">
                
                <div class="d-flex flex-column justify-content-center ml-3">
                  <span class="card-post__author-name">
                    {{ request.names }} {{ request.lastnames }}
                  </span>
                  <small class="text-muted">
                    <i class="fas fa-calendar-day mr-2"></i>
                    <convert-date :date="request.created_at"/>
                  </small>
                </div>
              </div>

              <div class="my-auto ml-auto mr-2">
                <a class="btn btn-sm btn-white ml-auto" :href="request.file" target="_blank" download="Curriculum">
                  <i class="fas fa-file"></i> 
                  Descargar CV 
                </a>
              </div>

              <div class="my-auto mr-2" v-if="request.linkedin">
                <a class="btn btn-sm btn-white" :href="request.linkedin">
                  <i class="fab fa-linkedin-in"></i>
                </a>
              </div>

              <div class="my-auto">
                <a class="btn btn-sm btn-white" :href="'mailto:' + request.email">
                  <i class="fas fa-envelope"></i>
                  Contactar 
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NotificationMessage from '@/components/general/NotificationMessage.vue';
  export default {
    components: { NotificationMessage },

    data() {
      return {
        requests: []
      }
    },

    mounted() {
      this.getRequests();
    },

    methods: {
      async getRequests() {
        let url = process.env.VUE_APP_ROOT_API.concat('/job');
        let response = await fetch(url);
        this.requests = await response.json();
      }
    }
  }
</script>